import { render, staticRenderFns } from "./dingdProductslist.vue?vue&type=template&id=32d670f7&scoped=true"
import script from "./dingdProductslist.vue?vue&type=script&lang=js"
export * from "./dingdProductslist.vue?vue&type=script&lang=js"
import style0 from "./dingdProductslist.vue?vue&type=style&index=0&id=32d670f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d670f7",
  null
  
)

export default component.exports